<template>
  <div class="homeswiper">
    <swiper :options="swiperOption"
            ref="mySwiper">
      <swiper-slide v-for="(it_son, index_son) in childData.activityPublicitySubs"
                    :key="index_son">
        <img class="swiper-image"
             :src="it_son.url"
             alt="">
        <div class="baner_title _width">
          <p>{{it_son.introduce}}</p>
        </div>
        <span class="icon"
              v-if="childData.activityPublicitySubs.length!==0">{{index_son+1}}/{{childData.activityPublicitySubs.length}}
        </span>

      </swiper-slide>
      <div class="swiper-pagination"
           slot="pagination"></div>

    </swiper>

    <div class="swiper-button-prev swiper-button-black "
         :class="'swiper-button-prev_'+(childData.id)+''"
         slot="button-prev"></div>
    <div class="swiper-button-next swiper-button-black "
         :class="'swiper-button-next_'+(childData.id)+''"
         slot="button-next"></div>

  </div>
</template>

<script>
// 引入插件
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  name: "homeSwiper",
  props: ["childData"],

  data () {
    return {
      swiperOption: {
        notNextTick: false,
        loop: true,
        autoplay: {
          delay: 10000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true //允许分页点击跳转
        },

        observer: true,  // 启动动态检查器(OB/观众/观看者)，当改变swiper的样式（例如隐藏/显示）或者修改swiper的子元素时，自动初始化swiper。
        observeParents: true,  // 将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新。
        setWrapperSize: true, // Swiper使用flexbox布局(display: flex)，
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
          // nextEl: 'swiper-button-prev_' + (this.childData.id) + '',
          // prevEl: 'swiper-button-prev_' + (this.childData.id) + ''

        },

      }
    }
  },
  filters: {
    filterFun_as: function (value) {
      return value.replace('.jpg', '_as.jpg')//最大
    },
    filterFun_ss: function (value) {
      return value.replace('.jpg', '_activity_ss.jpg')//最小
    },
    filterFun_sss: function (value) {
      return value.replace('.jpg', '_activity_sss.jpg')//最小
    }

  },


  components: {
    swiper,
    swiperSlide
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted () {
    // console.log("this is current swiper instance object", this.swiper);
    this.swiper.slideTo(3, 1000, false);
  }
}
</script>
<style  scoped>
/* 懒加载loading */
img[lazy="loading"] {
  display: block;
  width: 0.5rem !important;
  height: 0.5rem !important;
  margin: 30% 50% auto;
}
.homeswiper >>> .swiper-wrapper {
  background-color: #fafafb;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 7.85rem;
}
.homeswiper {
  height: 100%;
  box-sizing: border-box;
}
.homeswiper >>> .swiper-container {
  height: 100%;
}
.swiper-box .swiper-slide {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.swiper-box .swiper-slide .swiper-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: all 0.3s;
}

.homeswiper >>> .swiper-button-black {
  border-radius: 50%;
  overflow: hidden;
  border: 1px solid #eee;
  width: 0.4rem;
  height: 0.4rem;
  transition: all 0.3s;
}

.homeswiper >>> .swiper-button-prev,
.homeswiper >>> .swiper-button-next {
  position: absolute;
  top: 50%;
  width: 0.35rem;
  height: 0.35rem;
  margin-top: -0.22rem;
  z-index: 10;
  cursor: pointer;
  background-size: 0.15rem 0.15rem;
  background-position: center;
  background-repeat: no-repeat;
}

.homeswiper >>> .swiper-button-black:hover {
  border: 1px solid #afaeae;
}

.homeswiper >>> .swiper-button-prev {
  left: -0.45rem;
}

.homeswiper >>> .swiper-button-next {
  right: -0.45rem;
}

.homeswiper >>> .swiper-button-prev:after,
.homeswiper >>> .swiper-button-next:after {
  font-size: 0.16rem;
}

/* banner 的title */
.baner_title {
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 0.5rem 0.15rem 0.2rem;
  font-family: "PingFang SC", "Lantinghei SC", "Microsoft YaHei", "HanHei SC",
    "Helvetica Neue", "Open Sans", Arial, "Hiragino Sans GB", "微软雅黑",
    STHeiti, "WenQuanYi Micro Hei", SimSun, sans-serif;

  font-size: 0.14rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 0.24rem;
  letter-spacing: 0.01rem;
  color: #ffffff;
  width: 100%;
  background-image: linear-gradient(
    -180deg,
    hsla(0, 0%, 74.9%, 0),
    rgba(0, 0, 0, 0.78) 97%
  );
  box-sizing: border-box;
}
.swiper_wp {
  border: 1px solid green;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

/* 封面icon */
.icon {
  /* width: 0.2rem;
  height: 0.21rem; */
  position: absolute;
  left: 0.1rem;
  top: 0.1rem;
  /* background-image: url("../../assets/image/avtivity_details/img.png");
  background-size: 100% 100%; */
  height: 0.25rem;
  font-size: 0.18rem;
  font-weight: 400;
  font-weight: normal;
  font-stretch: normal;
  line-height: 0.24rem;
  letter-spacing: 0rem;
  /* color: #6e6d7a; */
  text-align: center;
  font-family: TTCHJT--GB1-0;
  padding: 0 0.08rem;
  color: rgba(255, 255, 255, 0.8);
  backdrop-filter: saturate(180%) blur(20px);
  -webkit-backdrop-filter: blur(20px);
  background-color: rgba(0, 0, 0, 0.3);
  /* box-shadow: 0 4px 4px 0 rgb(48 48 48 / 15%), 0 0 0 15px #f3f5f9; */
  border-radius: 999em;
  overflow: hidden;
  font-stretch: normal;
  box-sizing: border-box;
}

.img_icon img {
  width: 100%;
  float: left;
}
</style>


// WEBPACK FOOTER //
// src/components/swiper/activityDetailsSwiper.vue